<ui-object-navigation-main-page alias="pm"></ui-object-navigation-main-page>